import { render, staticRenderFns } from "./Memory.vue?vue&type=template&id=03ddcb30&scoped=true&"
import script from "./Memory.vue?vue&type=script&lang=ts&"
export * from "./Memory.vue?vue&type=script&lang=ts&"
import style0 from "./Memory.styl?vue&type=style&index=0&id=03ddcb30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ddcb30",
  null
  
)

export default component.exports